import { DriftUserIF } from '@driftt/app-config/dist/utils/driftTypes'

export const getDisplayName = (user: DriftUserIF | undefined) => {
  return user?.name || user?.role || 'Unknown User'
}

export const getUserDisplayRole = (user: DriftUserIF | undefined) => {
  return user?.roles && user.roles[0]
}
